import React from 'react';
import './index.css';

function TabSwtich(props) {

    const renderTabs = (item, index)=>{
        let cls = '';

        if(item.active){
            cls = 'active'
        }else{
            cls = 'inactive'
        }
        return(
            <div
             key={index} 
            onClick={item.onClick} 
            className={`Tab ${cls}`} 
            style={!props.grow ? { flexGrow: 1, flexShrink: 0, padding: '10px 5px', textAlign: 'center' } : {}}
            >
           {item.name}
           </div>
        )
    }

    return (<>
        <div className='TabSwitch' style={{...props.style,overflowX:'scroll'}}>
            {props.tabs.map(renderTabs)}
        </div>
    </>);
}

export default TabSwtich;